import { Component, OnInit, NgZone } from '@angular/core';
import { ServicesService } from '../../services/services.service';
import swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-create-project-order',
  templateUrl: './create-project-order.component.html',
  styleUrls: ['./create-project-order.component.css']
})

export class CreateProjectOrderComponent implements OnInit {

  public routePath;

  addProjectOrderForm: FormGroup;
  isFormSubmitted=false;
  showloader = false;

    constructor(private modalService: NgbModal,
      private _services: ServicesService,
      private formBuilder: FormBuilder){

    }

    ngOnInit() {
      this.addProjectOrderForm = new FormGroup({
        'project_name': new FormControl('', [Validators.required]),
        'address': new FormControl('', [Validators.required]),
        'project_commencement_date': new FormControl('', [Validators.required])
      });
    }
    isLoader: boolean = false;


// convenience getter for easy access to form fields 
get f() { return this.addProjectOrderForm.controls; }

    addOrderProject(){
      this.isFormSubmitted = true;
      //console.log(this.addProjectOrderForm);
      this.showloader = true;

      //It will not allow to submit form until all input's filled.
      if(this.addProjectOrderForm.status != 'VALID'){
        this.showloader = false;
        this.isFormSubmitted=false;
        return false;
      }

      this.routePath = 'create-project-order';
      this._services.requestCreator(this.addProjectOrderForm.value,this.routePath,this._services.getToken()).subscribe((data: any) => {
          this._services.checkToken(data.status);
            if(data.status == '200'){
              this.showloader = false;
              this.isFormSubmitted=false;
              swal({
                title: 'Project',
                text: 'Project Added Successfully',
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: 'rgb(17, 205, 239)',
                cancelButtonColor: 'rgb(245, 54, 92)',
                confirmButtonText: 'Yes'
              }).then(() => {
                  this.resetProjectOrderForm();
              })
            }else{
              this.showloader = false;
              this.isFormSubmitted=false; 
            }
          }
      );
    }

    resetProjectOrderForm(){
      this.addProjectOrderForm.reset();
    }

  }

